export const CardRowStyle: React.CSSProperties = {
    display: 'flex',
    flexDirection: 'row',
    position: 'relative',
    alignSelf: 'center',
    alignContent: 'center',
    justifyContent: 'left',
    minWidth: '80vw',
    gap: '24px',
    margin: 'auto 20px',
};
